module.exports = __webpack_public_path__ + "img/apple_store.384b4f8.png";